var React = require('react');

function Male (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M32 64a64 64 0 1 1 64 64 64 64 0 0 1-64-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M48 144h11.36a87.91 87.91 0 0 0 73.28 0H144a48 48 0 0 1 48 48v136a24 24 0 0 1-24 24h-16v136a24 24 0 0 1-24 24H64a24 24 0 0 1-24-24V352H24a24 24 0 0 1-24-24V192a48 48 0 0 1 48-48z","className":"fa-primary","key":2})]);
}

Male.defaultProps = {"viewBox":"0 0 192 512","className":"icon"};

module.exports = Male;

Male.default = Male;
